
/**
 * React hook to monitor route changes
 */
import { useEffect, useState } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { endNavigation } from './navigationTracker';
import { navigationState } from './navigationState';

export const useNavigationMonitor = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const [lastNavigation, setLastNavigation] = useState<string | null>(null);
  
  useEffect(() => {
    // End any previous navigation
    if (navigationState.inProgress) {
      endNavigation();
    }
    
    // Set last navigation
    setLastNavigation(location.pathname);
    
    // Consider navigation complete after component renders
    const timeoutId = setTimeout(() => {
      // Update last completed path
      navigationState.lastCompletedPath = location.pathname;
      
      // End any lingering loading indicators
      if (window._loadingIndicator) {
        window._loadingIndicator.endRequest();
      }
    }, 100);
    
    return () => {
      clearTimeout(timeoutId);
    };
  }, [location.pathname, navigationType]);
  
  return { lastNavigation };
};
